export default class MenuTabs {
  constructor() {
    this.menu = $('.mobile-menu .menu-primary');
    this.meta = $('.mobile-menu menu-meta');
    this.back = $('.tab-slideback');
    this.context = $('.tab-context');
    
    this.submenuVisible = false;
    this.current = null;
    this.currentTabIndex = 0;

    this.initMainMenu();

    return this;
  }

  initMainMenu() {
    const $menuItem = $('> .menu-item-has-children > a', this.menu);
    const $back = $('.tab-slideback');

    // Run once
    this.preventTabOverflow();

    $menuItem.off().on('click', (e) => {
      e.preventDefault();
      this.slideFurther(e);
      this.update();
    });

    $back.off().on('click', (e) => {
      e.preventDefault();
      this.slideBack(e);
      this.update();
    });
  }

  slideFurther(e) {
    this.currentTabIndex += 1;
    const $target = $(e.currentTarget);
    const margin = this.getCurrentTabMargin();

    $target.parents('.menu').addClass(`level-${margin}-on-display`);
    this.current = $target.parents('.dropdown').eq(0);
    this.current.addClass('menu-item-open-submenu');
  }

  slideBack() {
    const margin = this.getCurrentTabMargin();
    $('.menu-primary').removeClass(`level-${margin}-on-display`);

    this.currentTabIndex -= 1;
    
    this.current.removeClass('menu-item-open-submenu');
  }

  update() {
    this.preventTabOverflow();
    this.setCurrentTabContext();
    this.setMobileMenuHeight();
    this.hideMeta();
  }

  getCurrentTabMargin() {
    return this.currentTabIndex;
  }

  setMobileMenuHeight() {
    const submenu = $('.menu-item-open-submenu .dropdown-menu', this.menu).last();
    let newHeight = submenu.height();

    if (!this.initialHeight) {
      this.initialHeight = this.menu.height();
    }

    if (!newHeight || newHeight === 0) {
      newHeight = this.initialHeight;
    }

    this.menu.height(newHeight);
  }

  preventTabOverflow() {
    const margin = this.getCurrentTabMargin();

    if (margin === 0) {
      $('.mega-menu-wrap').hide();
      this.submenuVisible = false;
    } else {
      this.submenuVisible = true;
    }
  }

  /**
   * Shows the user what menu item the current submenu belongs to
   */
  setCurrentTabContext() {
    const parent = $('.menu-item-open-submenu').last().eq(0);
    const contextHolder = $('.menu-item-open-submenu .dropdown-menu').last();

    if (contextHolder.length) {
      this.context = this.context.prependTo(contextHolder);
      this.context.toggleClass('visible', this.submenuVisible);

      $('.context-text', this.context).text($('> .nav-link', parent).text());
      $('.context-description', this.context).text($('> .menu-item-description', parent).text());

      $('a.nav-link', this.context).attr('href', $('> .nav-link', parent).attr('href'));
    }
  }

  hideMeta() {
    this.meta.toggle(!this.submenuVisible);
  }

  /**
   * Makes clicking the menu possible again
   * without trying to slide it out of the user's view
   */
  destroy() {
    const $menuItem = $('> .menu-item-has-children > a', this.menu);
    const $back = $('.tab-slideback');

    $menuItem.off();
    $back.off(); // lol
  }
}
